module.exports = __webpack_public_path__ + "static/caddy-trendline-7d6e6b5ec0d7807ef5d51ec3e50e6c1e.png";